
import { EstoqueServiceAdapter } from "@/usecases/deposito";
import { Inject } from "inversify-props";


export class ExportAllItensEstoqueUseCase {

	@Inject('EstoqueServiceAdapter')
	private estoqueService!: EstoqueServiceAdapter

	exportEstoque(idTabela: string): Promise<any> {
		return this.estoqueService.exportEstoque(idTabela)
	}
}